<template>
    <div class="jobs-post" style="vertical-align: middle;text-align: center">
        <!-- ============= 推荐岗位 ============= -->
        <div class="job-recommend" style="height:auto;padding-bottom: 12px;">
            <div class="job-recommend-title" style="width: 100%;display: inline-block">
                <div>
                    <div class="detaile-title">{{type_name}}</div>
                    <div class="detaile-select">
                        <el-select v-model="work_id" style="width: 360px" @change="change_work">
                            <el-option key="" label="所有岗位" value=""></el-option>
                            <el-option 
                                    v-for="(item,index) in work_arr"
                                    :key="index"
                                    :label="item"
                                    :value="index"
                            ></el-option>
                        </el-select>
                        <el-select v-model="site_id" style="width: 360px" @change="change_site">
                            <el-option key="" label="所有站点" value=""></el-option>
                            <el-option 
                                    v-for="(item,index) in site_arr"
                                    :key="index"
                                    :label="item"
                                    :value="index"
                            ></el-option>
                        </el-select>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        简历投递：jianli@sinowealth.com  邮件主题：姓名+岗位+意向工作城市（合肥、西安、深圳或上海）
                    </div>
                </div>
                
                <el-table
                  :data="jobList"
                  stripe
                  :header-cell-style="{background:'rgba(239,245,255,1)',color:'#606266'}"
                   :cell-style="setRowStyle"
                  style="width: 80%;display: inline-block;">
                  <el-table-column prop="work_type" label="岗位名称" width="240"></el-table-column>
                  <el-table-column prop="site_id" label="工作地点" width="100"></el-table-column>
                  <el-table-column prop="study" label="学历要求"  width="100"></el-table-column>
                  <el-table-column prop="people" label="招聘人数"  width="80"></el-table-column>
                  <el-table-column prop="end_time" label="更新时间" align="center" width="240"></el-table-column>
                  <el-table-column prop="msg" :formatter="caseNumberFormatter" label="岗位职责与专业" style="white-space: pre-wrap;"></el-table-column>
                  <el-table-column prop="msg" :formatter="caseNumberFormatter2" label="" width="120"></el-table-column>
              </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/http/request'
    export default {
        data () {
            return {
                jobList: [],
                work_id:'',
                site_id:'',
                work_arr:[],
                site_arr:{},
            }
        },
        mounted:function(){
            this.getJobList();
            
            this.work_id=this.get_get_val('work_id');
            this.site_id=this.get_get_val('site_id');
        },
        methods: {
            reload:function () {
              window.location.reload();
            },
            getJobList: function () {
                let _this = this;
                // 获取参数type_id的值
                let work_id=this.work_id;
                let site_id=this.site_id;
                _this.loading = true
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/recruit?work_id='+work_id+'&site_id='+site_id,
                    }).then((response) =>{ // 这里使用了ES6的语法
                    _this.jobList = response.data.data
                    if(site_id==''){
                        _this.work_arr = response.data.work_arr
                        _this.site_arr = response.data.site_arr
                    }
                    
                    
                    
                    
                    
                    
                    _this.loading = false
                    this.newheight();
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            change_work: function (selVal) {
                this.work_id = selVal;
                this.getJobList();
            },
            change_site: function (selVal) {
                this.site_id = selVal;
                this.getJobList();
            },
            
            
            get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            },
            
            
            
            caseNumberFormatter2(row){
                 return <div style="white-space: pre-wrap;height:70px;cursor: pointer;" onclick="alert(this.parentNode.parentNode.previousElementSibling.children.item(0).children.item(0).innerHTML)">点击查看详情</div>;
            },
            caseNumberFormatter(row){
                 return <div style="white-space: pre-wrap;height:70px;cursor: pointer;" onclick="alert(this.innerHTML)">{row.msg}</div>;
                 
                 /*
                 
                 switch (row.confirmBy) {
                    case "1":
                      localStorage.setItem('signValue', 3)
                      return (
                        <span class="notRead" style="margin-left: 10px">
                          {row.caseNumber}
                        </span>
                      );
                    default:
                      return <span style="margin-left: 10px">{row.caseNumber}</span>;
                  }
                 */
            },
            
            
            
            /*setRowStyle({ row, column, rowIndex, columnIndex }){ 
                let that = this; let columns = [4]; //想要改变列的索引 
                if (columns.indexOf(columnIndex) > -1) { 
                    //有出现的话就返回center 
                    return "white-space: pre-wrap"; 
                  } else { 
                  return ""; //没有的话就返回left 
                } 
             }*/


        }
    }
    

    
</script>

<style>
  .jobs-post .el-divider--horizontal {height: 1px;margin: 0;background: rgba(74,144,226,1);width: 1200px;}
  .jobs-post .jobs-post-introduce { height: 800px;background-color: rgba(246,246,246,1);padding-top: 60px;width: 100% !important; }
  .jobs-post .jobs-introduce-box { background-color: #fff;width: 1200px;margin: 0 auto;height: 640px  }
  .jobs-post .box-title { background-color: rgba(239,245,255,1);width: 1200px;height: 40px; }
  .jobs-post .box-detaile { padding-top: 10px;font-size: 20px }
  .jobs-post .jobs-description { width: 1200px;margin: 0 auto;margin-left: 20px }
  .jobs-post .description-span { width:1000px;color: rgba(102,102,102,1) }
  .jobs-post .description-claim { width: 1200px;margin: 0 auto;margin-top: 80px;margin-left: 20px }
  .jobs-post .claim-span {  width:1000px;color: rgba(102,102,102,1) }
  .jobs-post .apply-job { margin: 40px;height: 40px }
  .jobs-post .job-recommend { height: 360px;background-color: #edeff3;width: 100% }
  .jobs-post .job-recommend-title { height: 200px;width: 1200px;padding-top: 40px }
  .jobs-post .el-table th>.cell, .product li { color: rgba(51,51,51,1); }
</style>



// WEBPACK FOOTER //
// src/pages/jobs/post.vue